import { combineReducers } from "redux";
import {
  ADD_ASSISTANTSHIP_REQUEST,
  DELETE_ASSISTANTSHIP_REQUEST,
  EDIT_ASSISTANTSHIP_REQUEST,
  TOGGLE_ASSISTANTSHIP_NOTIFY_REQUEST,
} from "../constants";
import { FETCH_DOCTOR_REQUEST } from "../../doctor/constants";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import { AssisstantshipItem, AssisstantshipsAction, IsFetching } from "../types";
import { Action as DoctorAction } from "../../doctor/types";

function items(
  state: AssisstantshipItem = {},
  action: AssisstantshipsAction | DoctorAction
): AssisstantshipItem {
  let officeId = action.data ? action.data.officeId : 0;
  let selectAssistant = null;
  let newState = { ...state };

  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTOR_REQUEST):
      action.payload.offices.forEach((office) => {
        return (newState[office.id] = office.assistantships);
      });
      return newState;

    case DELETE_ASSISTANTSHIP_REQUEST:
      selectAssistant = state[officeId].map((assistant) =>
        assistant.id === action.data.assistantId
          ? {
              ...assistant,
              isFetching: true,
            }
          : assistant
      );
      return { ...state, [officeId]: selectAssistant };
    case getSuccessActionType(DELETE_ASSISTANTSHIP_REQUEST):
      selectAssistant = state[officeId].filter((assistant) => assistant.id !== action.data.assistantId);
      return { ...state, [officeId]: selectAssistant };

    case TOGGLE_ASSISTANTSHIP_NOTIFY_REQUEST:
      selectAssistant = state[officeId].map((assistant) =>
        assistant.id === action.data.assistantId
          ? {
              ...assistant,
              isFetching: true,
            }
          : assistant
      );
      return { ...state, [officeId]: selectAssistant };
    case getSuccessActionType(TOGGLE_ASSISTANTSHIP_NOTIFY_REQUEST):
      selectAssistant = state[officeId].map((assistant) =>
        assistant.id === action.payload.id
          ? {
              ...assistant,
              notify: action.payload.notify,
              isFetching: false,
            }
          : assistant
      );
      return { ...state, [officeId]: selectAssistant };
    case getFailureActionType(TOGGLE_ASSISTANTSHIP_NOTIFY_REQUEST):
      selectAssistant = state[officeId].map((assistant) =>
        assistant.id === action.data.assistantId
          ? {
              ...assistant,
              isFetching: false,
            }
          : assistant
      );
      return { ...state, [officeId]: selectAssistant };

    case getSuccessActionType(ADD_ASSISTANTSHIP_REQUEST):
      return { ...state, [officeId]: [...state[officeId], action.payload] };

    case EDIT_ASSISTANTSHIP_REQUEST:
      selectAssistant = state[officeId].map((assistant) =>
        assistant.id === action.data.assistantId
          ? {
              ...assistant,
              isFetching: true,
            }
          : assistant
      );
      return { ...state, [officeId]: selectAssistant };
    case getSuccessActionType(EDIT_ASSISTANTSHIP_REQUEST):
      selectAssistant = state[officeId].map((assistant) =>
        assistant.id === action.payload.id
          ? {
              ...action.payload,
              isFetching: false,
            }
          : assistant
      );
      return { ...state, [officeId]: selectAssistant };
    case getFailureActionType(EDIT_ASSISTANTSHIP_REQUEST):
      selectAssistant = state[officeId].map((assistant) =>
        assistant.id === action.data.assistantId
          ? {
              ...assistant,
              isFetching: false,
            }
          : assistant
      );
      return { ...state, [officeId]: selectAssistant };
    default:
      return state;
  }
}

function isFetching(state: IsFetching = {}, action: AssisstantshipsAction): IsFetching {
  let officeId = action.data ? action.data.officeId : 0;

  switch (action.type) {
    case ADD_ASSISTANTSHIP_REQUEST:
      return { ...state, [officeId]: true };
    case getSuccessActionType(ADD_ASSISTANTSHIP_REQUEST):
    case getFailureActionType(ADD_ASSISTANTSHIP_REQUEST):
      return { ...state, [officeId]: false };

    default:
      return state;
  }
}

export const assistantship = combineReducers({ items, isFetching });
